function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#1E72D7",
  clipPath: "url(#clip0_11039_527652)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.1 1.72V.18c0-.1-.08-.18-.18-.18H.18C.08 0 0 .08 0 .18v39.63c0 .1.08.19.18.19h5.74c.1 0 .18-.08.18-.19v-1.56c0-.1-.08-.18-.18-.18H2.15a.18.18 0 01-.18-.18V2.09c0-.1.08-.18.18-.18h3.77c.1 0 .19-.08.19-.19zM12.17 8.05H8.62a.3.3 0 00-.3.3v3.58c0 .17.14.3.3.3h3.55a.3.3 0 00.3-.3V8.35a.3.3 0 00-.3-.3zM23.19 8.04h-3.55a.3.3 0 00-.3.3v3.6c0 .16.13.3.3.3h3.55a.3.3 0 00.3-.3v-3.6a.3.3 0 00-.3-.3zM34.19 8.03h-3.55a.3.3 0 00-.3.3v3.6c0 .17.14.3.3.3h3.55a.3.3 0 00.3-.3v-3.6a.3.3 0 00-.3-.3zM12.18 27.8H8.63a.3.3 0 00-.3.31v3.56c0 .16.13.3.3.3h3.55a.3.3 0 00.3-.3V28.1a.3.3 0 00-.3-.3zM23.2 27.78h-3.56a.3.3 0 00-.3.3v3.59c0 .16.13.3.3.3h3.55a.3.3 0 00.3-.3v-3.6a.3.3 0 00-.3-.3zM34.2 27.8h-3.55a.3.3 0 00-.3.3v3.56c0 .17.14.3.3.3h3.55a.3.3 0 00.3-.3V28.1a.3.3 0 00-.3-.3zM12.17 17.92H8.62a.3.3 0 00-.3.3v3.56c0 .16.14.3.3.3h3.55a.3.3 0 00.3-.3v-3.55a.3.3 0 00-.3-.3zM23.18 17.92h-3.55a.3.3 0 00-.3.3v3.56c0 .16.14.3.3.3h3.55a.3.3 0 00.3-.3v-3.56a.3.3 0 00-.3-.3zM34.2 17.93h-3.55a.3.3 0 00-.3.3v3.56c0 .16.14.3.3.3h3.55a.3.3 0 00.3-.3v-3.56a.3.3 0 00-.3-.3zM36.71 38.28v1.53c0 .1.09.19.19.19h5.74c.1 0 .18-.08.18-.19V.18c0-.1-.08-.18-.18-.18H36.9c-.1 0-.18.08-.18.18v1.57c0 .1.08.18.18.18h3.77c.1 0 .19.08.19.18v35.8c0 .1-.09.18-.19.18H36.9c-.1 0-.18.08-.18.19z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_11039_527652"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h42.82v40H0z"
})));

function SvgMatrix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    fill: "none",
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrix);
export default __webpack_public_path__ + "static/media/matrix.b6cc4159.svg";
export { ForwardRef as ReactComponent };